import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';

import { VideoFunction, VideoFunctionListItem, VideoFunctionListRequestPayload } from './models/videoFunction';

const videoFunctionListService = {
  getVideoFunctionList(params: VideoFunctionListRequestPayload): Promise<CommonResponse<VideoFunctionListItem[]>> {
    const url = `/video-functions`;
    return axiosClient.get(url, { params });
  },
  add(payload: Partial<VideoFunction>): Promise<CommonResponse<any>> {
    const url = '/video-functions';
    return axiosClient.post(url, payload);
  },
  updates(payload: Partial<VideoFunction[]>): Promise<CommonResponse<any>> {
    const url = `/video-functions`;
    return axiosClient.patch(url, payload);
  },
};

export default videoFunctionListService;
